import React from "react";
import { SvgIcon, SvgIconProps } from "@mui/material";
const AppIconsSearch = React.forwardRef((props: SvgIconProps, ref: any) => {
  return (
    <SvgIcon {...props} ref={ref}>
      <g fill="currentColor">
        <path
          d="M6.8911362,13.0664797c0.1317697,0,0.2680054-0.0513678,0.3685074-0.1496372
		c0.0893354-0.0893345,0.1362371-0.2188711,0.1250701-0.3573408c-0.008934-0.1250696-0.0625343-0.2456713-0.1496367-0.3327742
		l-0.004467-0.004467L2.5070117,8.0346737h20.3572578v-0.97822H2.5070117l4.7280655-4.2166209
		c0.1853704-0.1853702,0.2010045-0.4779425,0.0335007-0.6789465L7.257411,2.1497192
		C7.0720406,1.9643477,6.7794685,1.9487151,6.578464,2.1162186L6.57623,2.1184514L0.8989783,7.1770568
		C0.8029432,7.2730918,0.724775,7.4405951,0.7560428,7.6013989c0.0089327,0.1384697,0.102735,0.2456717,0.1429355,0.288105
		l0.004467,0.004467l5.6705518,5.0519052C6.6566324,13.0262775,6.7727656,13.0664797,6.8911362,13.0664797z"
        />
        <path
          d="M23.2439423,16.3986835v-0.0000019c-0.008934-0.1384697-0.1027336-0.2456703-0.1429367-0.288105
		l-0.004467-0.004467l-5.6683178-5.0496731c-0.0893345-0.087101-0.2188702-0.1317692-0.3528728-0.1228361
		c-0.1250687,0.008934-0.2456722,0.0625343-0.3327751,0.1496363c-0.0893345,0.0893354-0.1362343,0.2188711-0.1250687,0.3573408
		c0.008934,0.1250706,0.0625343,0.2456722,0.1496372,0.3327742l0.004467,0.004467l4.7235985,4.2121553H1.1357174v0.9782209
		h20.3572559l-4.725832,4.1920528c-0.1853695,0.1853714-0.201004,0.4779453-0.0335007,0.6789494l0.0111675,0.0111656
		C16.8453102,21.9508648,16.9748459,22,17.1043816,22c0.1139011,0,0.2255707-0.0379677,0.3193722-0.1161366l0.0022335-0.0022316
		l5.6794853-5.0586052C23.1970406,16.7269917,23.2752075,16.5594883,23.2439423,16.3986835z"
        />
      </g>
    </SvgIcon>
  );
});

export default AppIconsSearch;
